import React from "react";

import { AuthProvider } from "../services/hooks/auth";

interface AppProps {
  children: React.ReactNode;
}

export const AppContext = ({ children }: AppProps) => (
  <AuthProvider>{children}</AuthProvider>
);
